// admins/group-list
import React from 'react';
import View from 'src/pages/admins/groups/list';
import { useItemsSearch, groupsApi } from 'src/api/groups/vm-view';

const Page = () => {
  const search = useItemsSearch();
  const store = groupsApi.getTree(search.state);

  return <View dataSearch={search} dataStore={store} />;
};

export default Page;
